import { Avatar, Card, Colors, Icon, Pills } from '@amelio/ui-library';

import type { User } from '@/types/directory/User';

import { UserCard } from '@/components/UserCard/UserCard';

export interface DesktopRevieweeCardProps {
    isSelfEvaluation: boolean;
    reviewee?: User;
    revieweeFullName: string;
    revieweeJobTitle: string;
    revieweeProfilePictureUrl: string;
    selfEvaluationPillLabel: string;
    reviewedColleaguePillLabel: string;
}

export const DesktopRevieweeCard = ({
    isSelfEvaluation,
    reviewee,
    revieweeFullName,
    revieweeJobTitle,
    revieweeProfilePictureUrl,
    selfEvaluationPillLabel,
    reviewedColleaguePillLabel,
}: DesktopRevieweeCardProps) => {
    const pillLabel = isSelfEvaluation ? selfEvaluationPillLabel : reviewedColleaguePillLabel;

    return (
        <div className={'relative'}>
            <Card
                className={'border-2'}
                borderColor={Colors.PRIMARY}
                borderRadius={'2xl'}
            >
                <Pills
                    className={'absolute -top-3 -right-3 z-10 max-w-50'}
                    variant={'primary'}
                >
                    {pillLabel}
                </Pills>

                <div className={'flex flex-col gap-4 p-3'}>
                    <Card
                        className={'flex flex-row items-center justify-between bg-white px-2'}
                        key={reviewee?.id}
                        padding={'none'}
                        borderRadius={'2xl'}
                    >
                        <UserCard
                            alt={`${reviewee?.firstName} ${reviewee?.lastName}`}
                            avatar={
                                isSelfEvaluation ? (
                                    <div
                                        className={
                                            'bg-primary-50 flex h-12 w-12 shrink-0 items-center justify-center rounded-full'
                                        }
                                    >
                                        <Icon
                                            name={'users-user'}
                                            size={24}
                                            color={Colors.PRIMARY}
                                        />
                                    </div>
                                ) : (
                                    <Avatar
                                        alt={revieweeFullName}
                                        src={revieweeProfilePictureUrl}
                                    />
                                )
                            }
                            description={revieweeJobTitle}
                            name={revieweeFullName}
                        />

                        <div className={'bg-base-100 ml-2 rounded-2xl p-4'}>
                            <Icon
                                name={'design-layer'} // TODO: Update the icon according to business requirements
                                color={Colors.SECONDARY}
                                size={'lg'}
                            />
                        </div>
                    </Card>
                </div>
            </Card>
        </div>
    );
};
